import styled from 'styled-components';

export const PDFWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .doc {
    border: 1px solid #ddd;
  }
`;
